<template>

    <form ref="instituicaoensino-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-12">
                <label for="tipoContratoInstituicaoEnsinoId">TipoContratoInstituicaoEnsinoId</label>
                <input type="text" class="form-control" name="tipoContratoInstituicaoEnsinoId" placeholder="TipoContratoInstituicaoEnsinoId" v-model="model.tipoContratoInstituicaoEnsinoId" required />
            </div>
            <div class="form-group col-md-12">
                <label for="dataInicioParceria">DataInicioParceria</label>
                <input type="text" v-datepicker class="form-control" name="dataInicioParceria" v-model="model.dataInicioParceria" />
            </div>
            <div class="form-group col-md-12">
                <label for="dataTerminoParceria">DataTerminoParceria</label>
                <input type="text" v-datepicker class="form-control" name="dataTerminoParceria" v-model="model.dataTerminoParceria" />
            </div>
            <div class="form-group col-md-12">
                <label for="contato">Contato</label>
                <input type="text" class="form-control" name="contato" placeholder="Contato" v-model="model.contato" />
            </div>
            <div class="form-group col-md-12">
                <label for="tipoInstituicaoParceriaId">TipoInstituicaoParceriaId</label>
                <input type="text" class="form-control" name="tipoInstituicaoParceriaId" placeholder="TipoInstituicaoParceriaId" v-model="model.tipoInstituicaoParceriaId" />
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="permiteCompraAutomatica" class="custom-control-input" v-model="model.permiteCompraAutomatica">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> PermiteCompraAutomatica?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="permiteBoleto" class="custom-control-input" v-model="model.permiteBoleto">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> PermiteBoleto?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <label for="numeroParcelaBoleto">NumeroParcelaBoleto</label>
                <input type="text" class="form-control" name="numeroParcelaBoleto" placeholder="NumeroParcelaBoleto" v-model="model.numeroParcelaBoleto" />
            </div>
            <div class="form-group col-md-12">
                <label for="numeroParcelaCartao">NumeroParcelaCartao</label>
                <input type="text" class="form-control" name="numeroParcelaCartao" placeholder="NumeroParcelaCartao" v-model="model.numeroParcelaCartao" />
            </div>
            <div class="form-group col-md-12">
                <label for="situacaoInstituicaoEnsinoId">SituacaoInstituicaoEnsinoId</label>
                <input type="text" class="form-control" name="situacaoInstituicaoEnsinoId" placeholder="SituacaoInstituicaoEnsinoId" v-model="model.situacaoInstituicaoEnsinoId" required />
            </div>
            <div class="form-group col-md-12">
                <label for="codigoMicrosiga">CodigoMicrosiga</label>
                <input type="text" class="form-control" name="codigoMicrosiga" placeholder="CodigoMicrosiga" v-model="model.codigoMicrosiga" />
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="vendaCommerce" class="custom-control-input" v-model="model.vendaCommerce">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Venda pelo Commerce?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensino-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "instituicaoensino-form-create",
            
            resources: {
                create: 'instituicaoensino',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

